import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { authService } from '../features/admin/login/auth.service';

export const PrivateRoute = () => {
  const isAuthenticated = authService.isAuthenticated();

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;